import {createFeatureSelector, createSelector} from '@ngrx/store';
import {WindowGridState} from '../reducers';

const getWindowGridState = createFeatureSelector<WindowGridState>('windowGrid');

export const getWindowGrid = createSelector(
  getWindowGridState,
  (windowGrid) => windowGrid
);
